// extracted by mini-css-extract-plugin
module.exports = {"Left":"index_Left__JWWdG","Right":"index_Right__nmGC0","toggleArrowsBody":"index_toggleArrowsBody__1YLQO"};